import { adminApiRequest } from "../../utils/apiUtils";

export const AdjustAPI = {
  getAdjustDashBoard: () => {
    return adminApiRequest.get("/adjust").then((res) => res);
  },
};
